import { Component, Input, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { BaseInputSizes } from 'base';
import { BaseCustomerWorkCouncilStatusEnum } from '../../../_enums/base-customer-work-council-status.enum';

@Component({
  selector: 'base-customer-change-status-confirmation-modal',
  templateUrl: './base-customer-change-status-confirmation-modal.component.html',
})
export class BaseCustomerChangeStatusConfirmationModalComponent implements OnInit {
  @Input() modalRef: NgbModalRef;
  @Input() selectedStatus: BaseCustomerWorkCouncilStatusEnum | undefined;
  @Input() profileFullName!: string;

  inputSizes = BaseInputSizes;
  submitted = false;
  reasonFormControl = new FormControl('', { nonNullable: true });

  get hasDisapproveStatus() {
    return this.selectedStatus === BaseCustomerWorkCouncilStatusEnum.DISAPPROVED;
  }

  ngOnInit() {
    if (this.hasDisapproveStatus) {
      this.reasonFormControl.addValidators([Validators.required]);
      this.reasonFormControl.updateValueAndValidity();
    }
  }

  onConfirm() {
    this.submitted = true;

    if (this.reasonFormControl.valid) {
      this.modalRef.close(this.reasonFormControl.value);
    }
  }

  onClose() {
    this.modalRef.dismiss();
  }
}
